import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-phone',
  templateUrl: './icon-phone.component.svg',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPhoneComponent {}
